import React from 'react'
import { Switch, Route, Redirect, NavLink, Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getCurrentUser } from 'ducks/users/index.ts'

import Dashboard from './Dashboard.tsx'
import Users from './Users.tsx'
import AppDetail from './AppDetail'
import AdminUserDetail from './AdminUserDetail'
import Datasource from './Datasource'
import DeletedApp from './DeletedApp'
import Builds from './Builds'
import AppScreens from './AppScreens'
import { Libraries, Library } from './Marketplace'
import PQLFunnel from './PQLFunnel'
import AIAnalytics from './AIAnalytics.tsx'

const AdminRoutes = () => {
  const user = useSelector(state => getCurrentUser(state))

  // redirect non-admin user
  if (user && !user.admin) {
    return <Redirect to="/" />
  }

  return (
    <>
      <div style={{ marginBottom: '10px', padding: '20px' }}>
        <NavLink to="/admin">Dashboard</NavLink>
        {` • `}
        <NavLink to="/admin/users">Users</NavLink>
        {` • `}
        <Link to="/admin/marketplace">Marketplace Libraries</Link>
        {` • `}
        <NavLink to="/admin/pql">PQL Funnel</NavLink>
        {` • `}
        <Link to="/admin/builds">Builds</Link>
        {` • `}
        <NavLink to="/admin/ai">AI Analytics</NavLink>
      </div>
      <Switch>
        <Route
          exact
          path="/admin"
          component={() => <Redirect to="/admin/dashboard" />}
        />
        <Route path="/admin/dashboard" component={Dashboard} />
        <Route exact path="/admin/users" component={Users} />
        <Route exact path="/admin/users/:userId" component={AdminUserDetail} />
        <Route exact path="/admin/marketplace" component={Libraries} />
        <Route exact path="/admin/users/:userId/:appId" component={AppDetail} />
        <Route
          exact
          path="/admin/datasource/:datasourceId"
          component={Datasource}
        />
        <Route exact path="/admin/app-screens/:appId" component={AppScreens} />
        <Route exact path="/admin/deleted-app/:appId" component={DeletedApp} />
        <Route
          exact
          path={[
            '/admin/marketplace/:libraryName',
            '/admin/marketplace/:libraryAuthor/:libraryName',
          ]}
          component={Library}
        />
        <Route exact path="/admin/builds" component={Builds} />
        <Route exact path="/admin/pql" component={PQLFunnel} />
        <Route exact path="/admin/ai" component={AIAnalytics} />
      </Switch>
    </>
  )
}

export default AdminRoutes
